
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconControlsPlay = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M23.14 10.608L2.253.164A1.559 1.559 0 0 0 0 1.557v20.887a1.558 1.558 0 0 0 2.253 1.392L23.14 13.393a1.557 1.557 0 0 0 0-2.785z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M2.121 23.38a1.495 1.495 0 0 1-1.502-1.499V2.117A1.503 1.503 0 0 1 2.789.775l19.764 9.882c.359.18.625.488.752.868s.097.787-.083 1.145a1.503 1.503 0 0 1-.669.669L2.789 23.222c-.21.105-.435.158-.668.158zM2.119 1.618a.5.5 0 0 0-.5.5v19.764a.502.502 0 0 0 .724.447l19.764-9.882a.497.497 0 0 0 0-.893L2.342 1.67a.507.507 0 0 0-.223-.052z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M3.839 22.995c-1.24 0-2.25-1.01-2.25-2.25V3.254c0-.37.092-.738.267-1.064a2.263 2.263 0 0 1 1.985-1.187c.367 0 .734.093 1.061.268l16.323 8.745c.392.21.71.528.92.92a2.24 2.24 0 0 1 .171 1.714 2.237 2.237 0 0 1-1.091 1.333L4.902 22.728a2.268 2.268 0 0 1-1.063.267zM3.84 2.504a.744.744 0 0 0-.218.033.753.753 0 0 0-.533.717v17.49a.75.75 0 0 0 1.104.661l16.324-8.745a.74.74 0 0 0 .363-.444.748.748 0 0 0-.363-.879L4.194 2.594a.736.736 0 0 0-.354-.09z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconControlsPlay.displayName = 'IconControlsPlay';
export default IconControlsPlay;